import { mediaItems } from '@/mocks/home';

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          精彩剧集
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-fill text-lg"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次播放
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}